import React, { forwardRef, useImperativeHandle, useState } from "react";
import BaseImport from "../Imports/BaseImport";

const BaseImportModal = forwardRef(({ importData, apiURL }, ref) => {
  const [show, setShow] = useState(false);
  useImperativeHandle(ref, () => ({
    open: () => {
      setShow(true);
    },
    close: () => {
      setShow(false);
    },
  }));

  return (
    <BaseImport
      setShow={setShow}
      show={show}
      api={apiURL}
      shouldUniqueColumn={importData.shouldUniqueColumn}
      shouldExistColumns={importData.shouldExistColumns}
      shouldBeUniqueCompositeColumns={importData.shouldBeUniqueCompositeColumns}
      nullableColumns={importData.nullableColumns}
      columns={importData.columns}
      dataName={importData.dataName}
      enableAddMode={importData.enableAddMode}
    />
  );
});

export default BaseImportModal;
